<template>
  <div class="container">
    <AddTask v-if="showAddTask" @add-task="addTask" />
    <Tasks
      @toggle-reminder="toggleRreminder"
      @delete-task="deleteTask"
      :tasks="tasks"
    />
  </div>
</template>

<script>
import AddTask from '../components/AddTask';
import Tasks from '../components/Tasks';

export default {
  name: 'Home',
  props: {
    showAddTask: Boolean,
  },
  components: {
    Tasks,
    AddTask,
  },
  data() {
    return {
      tasks: [],
    };
  },
  methods: {
    async deleteTask(id) {
      if (confirm('Do you want to delete this task?')) {
        const res = await fetch(
          `https://json-server-vue-task-tracker-milos.glitch.me/tasks/${id}`,
          {
            method: 'DELETE',
          }
        );

        res.status === 200
          ? (this.tasks = this.tasks.filter((task) => task.id !== id))
          : alert('Error deleting Task!');
      }
    },
    async toggleRreminder(id) {
      const taskToToggle = await this.fetchTask(id);
      const updatedTask = { ...taskToToggle, reminder: !taskToToggle.reminder };

      await fetch(
        `https://json-server-vue-task-tracker-milos.glitch.me/tasks/${id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedTask),
        }
      );

      this.tasks = this.tasks.map((task) =>
        task.id === id ? { ...task, reminder: !task.reminder } : task
      );
    },
    async addTask(task) {
      const res = await fetch(
        'https://json-server-vue-task-tracker-milos.glitch.me/tasks',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(task),
        }
      );

      const data = await res.json();

      this.tasks = [...this.tasks, data];
    },

    async fetchTasks() {
      const res = await fetch(
        'https://json-server-vue-task-tracker-milos.glitch.me/tasks'
      );
      const data = await res.json();

      return data;
    },
    async fetchTask(id) {
      const res = await fetch(
        `https://json-server-vue-task-tracker-milos.glitch.me/tasks/${id}`
      );
      const data = await res.json();

      return data;
    },
  },
  async created() {
    this.tasks = await this.fetchTasks();
  },
};
</script>
